if (!customElements.get('pack-options-guard')) {
  customElements.define(
    'pack-options-guard',
    class PackOptionsGuard extends HTMLElement {
      connectedCallback() {
        this.button = document.getElementById(this.dataset.source);
        this.container = document.getElementById('infiniteoptions-container');
        this.notice = this.querySelector('.pack-options-notice');
        if (!this.button || !this.container || !this.notice) return;

        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);

        document.addEventListener('click', this.onClick, true);
        this.container.addEventListener('change', this.onChange);

        this.replaceAppAlert();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onClick, true);
        this.container?.removeEventListener('change', this.onChange);
      }

      // El boton de la ficha y el de la barra fija envian el mismo formulario.
      isAddToCartButton(element) {
        const button = element.closest?.('button[type="submit"]');
        if (!button) return false;

        return button === this.button || button.getAttribute('form') === this.dataset.form;
      }

      onClick(event) {
        if (!this.isAddToCartButton(event.target)) return;

        const pending = this.firstPendingGroup();
        if (!pending) return;

        // La app tambien frena el boton de la ficha, pero no el de la barra
        // fija, asi que el aviso y el freno corren por nuestra cuenta.
        event.preventDefault();
        event.stopPropagation();
        this.showNotice(pending);
      }

      onChange() {
        this.notice.setAttribute('hidden', '');
      }

      firstPendingGroup() {
        const fieldsets = this.container.querySelectorAll('fieldset[data-required="true"]');

        for (const fieldset of fieldsets) {
          const input = fieldset.querySelector('input[type="hidden"][name^="properties"]');
          if (!input || input.value.trim() === '') return fieldset;
        }

        return null;
      }

      showNotice(fieldset) {
        const group = fieldset?.closest('#infiniteoptions-container > div');

        if (group) {
          group.parentNode.insertBefore(this.notice, group);
        } else {
          this.container.parentNode.insertBefore(this.notice, this.container);
        }

        this.notice.removeAttribute('hidden');

        const top = window.scrollY + this.notice.getBoundingClientRect().top - 120;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      }

      // La app avisa con una ventana del navegador en ingles; se cambia por
      // el aviso del tema.
      replaceAppAlert() {
        if (window.packOptionsAlertReplaced) return;
        window.packOptionsAlertReplaced = true;

        const nativeAlert = window.alert;
        const guard = this;

        window.alert = function (message) {
          if (/select your options/i.test(String(message || ''))) {
            guard.showNotice(guard.firstPendingGroup());
            return undefined;
          }

          return nativeAlert.apply(window, arguments);
        };
      }
    }
  );
}
